import React from 'react';
import {
    SimpleForm,
    TextInput,
    DateInput,
    ReferenceInput,
    SelectInput,
    required
} from 'react-admin';

import Create from '../common/views/Create';
import CategoryInput from './inputs/CategoryInput';
import StatusInput from './inputs/StatusInput';
import PriorityInput from './inputs/PriorityInput';
import ParticipantsInput from './inputs/ParticipantsInput';

const TaskCreate = props => (
    <Create {...props} redirect="show">
        <SimpleForm>
            <TextInput source="title" validate={required()} fullWidth />
            <TextInput source="description" multiline rows="4" fullWidth />
            <CategoryInput validate={required()} />
            <StatusInput />
            <PriorityInput />
            <ReferenceInput source="owner_id" reference="users">
                <SelectInput optionText="fullname" validate={required()} />
            </ReferenceInput>
            <ParticipantsInput />
            <DateInput source="due_date" />
        </SimpleForm>
    </Create>
);

export default TaskCreate;
